import process from 'process/browser';
import { Buffer } from 'buffer';

const globalScope = globalThis as typeof globalThis & {
    process?: typeof process,
    Buffer?: typeof Buffer
};

if(!globalScope.process)
    globalScope.process = process;

if(!globalScope.Buffer)
    globalScope.Buffer = Buffer;